import {PewComponent} from "../../../assets/raw/js/components/pew-component";
import {Menu} from "./Menu";

class headerComponent extends PewComponent {

    constructor(element, options) {
        let defaultOptions = {
            'classToToggleOnBody': 'has-opened-menu'
        };
        super(element, Object.assign(defaultOptions, options));
        this.menu = null;
    }

    init(){
        this.registerMenuToggler();
        this.registerSticky();
    }

    registerMenuToggler(){
        this.element.find('[data-menu-toggler]').on('click',(e)=>{
            e.preventDefault();
            if (!window.matchMedia("(min-width: 1024px)").matches) {
                if(this.menu===null) {
                    this.menu = new Menu(this.element.find('.navigation-wrapper'));
                }
            }
            $(e.currentTarget).toggleClass('is-active');
            $('body').toggleClass(this.options.classToToggleOnBody);
            this.menu.toggle();
        });
    }

    registerSticky(){

    }

}

window.pew.addRegistryEntry({key: 'header', domSelector: '#header', classDef: headerComponent});



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/Header/HeaderComponent.js